export const GET_PLAN = "plan/GET_PLAN";
export const GET_PLAN_META = "plan/GET_PLAN_META";
export const SHARE_PLAN = "plan/SHARE_PLAN";
export const SET_PLAN_STATE_TO_IN_PUBLISH = "plan/SET_PLAN_STATE_TO_IN_PUBLISH";
export const REFRESH_PLAN = "plan/REFRESH_PLAN";
export const SET_PLAN_COVER = "plan/SET_PLAN_COVER";
export const SET_PLAN_DESCRIPTION = "plan/SET_PLAN_DESCRIPTION";
export const SET_PLAN_TITLE = "plan/SET_PLAN_TITLE";
export const MOVE_TASK = "plan/MOVE_TASK";
export const ADD_TASK = "plan/ADD_TASK";
export const REMOVE_TASK = "plan/REMOVE_TASK";
export const RESET_PLAN = "plan/RESET_PLAN";
export const EDIT_TASK = "plan/EDIT_TASK";
export const REMOVE_TASK_PROP = "plan/REMOVE_TASK_PROP";
export const CLEAR_TASK = "plan/CLEAR_TASK";
export const SET_PLAN_META = "plan/SET_PLAN_META";
export const UPDATE_PLAN = "plan/UPDATE_PLAN";
export const PLAN_ACCEPTED = "plan/PLAN_ACCEPTED";
export const PLAN_DECLINED = "plan/PLAN_DECLINED";
export const CHANGE_PLAN_COPY = "plan/CHANGE_PLAN_COPY";
export const ADD_NEW_SCORE = "plan/ADD_NEW_SCORE";
export const EDIT_PLAN_SCORE = "plan/EDIT_PLAN_SCORE";
export const REMOVE_SCORE = "plan/REMOVE_SCORE";
export const GENERATE_TASKS = "plan/GENERATE_TASKS";
export const ADD_AUDIO = "plan/ADD_AUDIO";
export const REMOVE_AUDIO = "plan/REMOVE_AUDIO";
export const CHANGE_TASK_DESCRIPTION = "plan/CHANGE_TASK_DESCRIPTION";

export const ENABLE_EXPERIENCE_REQUEST = "plan/ENABLE_EXPERIENCE_REQUEST";
export const ENABLE_EXPERIENCE_SUCCESS = "plan/ENABLE_EXPERIENCE_SUCCESS";
export const ENABLE_EXPERIENCE_FAILURE = "plan/ENABLE_EXPERIENCE_FAILURE";

export const SET_EXPERIENCE = "plan/SET_EXPERIENCE";
